import { servers } from '../helpers'
import { Mid } from '@mid/sdk'

const server = Object.keys(servers).find(server => document.location.href.includes(servers[server].hub))

export const mid = new Mid({
  loginInfo: {
    appId: servers[server].mckid['appId'],
    oidcConfigUrl: servers[server].mckid['oidcConfigUrl'],
    authDriver: servers[server].mckid['authDriver']
  },
  redirectUrl: servers[server].mckid['redirectUrl'],
  logoutRedirectUrl: servers[server].mckid['logoutRedirectUrl'],
  scopes: servers[server].mckid['scopes']
})
